import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/'

// auth
import TandC from '../components/auth/pages/TandC.vue'
import Signin from '../components/auth/pages/Signin.vue'
import Signup from '../components/auth/pages/Signup.vue'
import Recovery from '../components/auth/pages/Recovery.vue'
import LockScreen from '../components/auth/pages/LockScreen.vue'
import VerifyEmail from '../components/auth/pages/VerifyEmail.vue'
import ResetPassword from '../components/auth/pages/ResetPassword.vue'
import ResetPasscode from '../components/auth/pages/ResetPasscode.vue'
import PrivacyPolicy from '../components/auth/pages/PrivacyPolicy.vue'
// general
import Home from '../components/general/pages/Home.vue'
import SiteSearch from '../components/general/pages/SiteSearch.vue'
import CategoryItems from '../components/general/pages/CategoryItems.vue'
import ItemDetails from '../components/general/pages/ItemDetails.vue'
import ItemPhotosAlbum from '../components/general/pages/itemDetailsParts/ItemPhotosAlbum.vue'
import ShoppingCart from '../components/general/pages/ShoppingCart.vue'
import SavedForLater from '../components/general/pages/SavedForLater.vue'
import Information from '../components/general/pages/checkoutParts/Information.vue'
import Shipping from '../components/general/pages/checkoutParts/Shipping.vue'
import Payment from '../components/general/pages/checkoutParts/Payment.vue'
import ProcessingOrder from '../components/general/pages/checkoutParts/ProcessingOrder.vue'
import OrderConfirmation from '../components/general/pages/checkoutParts/OrderConfirmation.vue'
import PaymentReceipt from '../components/general/pages/PaymentReceipt.vue'
// member
import CustomerAccount from '../components/member/pages/CustomerAccount.vue'
import CustomerOrders from '../components/member/pages/CustomerOrders.vue'
import CustomerOrder from '../components/member/pages/CustomerOrder.vue'
import CustomerAddresses from '../components/member/pages/CustomerAddresses.vue'
import CustomerSettings from '../components/member/pages/CustomerSettings.vue'
// user
import Profile from '../components/user/pages/Profile.vue'
import Buying from '../components/user/pages/Buying.vue'
import Selling from '../components/user/pages/Selling.vue'
import Likes from '../components/user/pages/Likes.vue'
import Alerts from '../components/user/pages/Alerts.vue'
import Transactions from '../components/user/pages/Transactions.vue'
import PostItem from '../components/user/pages/PostItem.vue'
import ModifyItem from '../components/user/pages/sellingParts/ModifyItem.vue'
import Messages from '../components/user/pages/Messages.vue'
import Settings from '../components/user/pages/Settings.vue'
import CreateShop from '../components/user/pages/CreateShop.vue'
import SellerPlans from '../components/user/pages/SellerPlans.vue'
import CreateReferrer from '../components/user/pages/profileParts/CreateReferrer.vue'
import Portal from '../components/user/pages/Portal.vue'
import PortalLookup from '../components/user/pages/portalParts/PortalLookup.vue'
import Marketers from '../components/user/pages/portalParts/Marketers.vue'
// shop
import Dashboard from '../components/shop/pages/Dashboard.vue'
import Items from '../components/shop/pages/Items.vue'
import Wallet from '../components/shop/pages/Wallet.vue'
import ManageItem from '../components/shop/pages/itemsParts/ManageItem.vue'
import Statement from '../components/shop/pages/walletParts/Statement.vue'
import Activities from '../components/shop/pages/Activities.vue'
import Shoppers from '../components/shop/pages/Shoppers.vue'
import ShopperRecords from '../components/shop/pages/shoppersParts/ShopperRecords.vue'
import Donations from '../components/shop/pages/Donations.vue'
import DonationHistory from '../components/shop/pages/donationsParts/DonationHistory.vue'
import Promotions from '../components/shop/pages/Promotions.vue' 
import PromotionPlans from '../components/shop/pages/promotionsParts/PromotionPlans.vue'
import Sales from '../components/shop/pages/Sales.vue'
import MainCategories from '../components/shop/pages/MainCategories.vue'
import ManageCategory from '../components/shop/pages/categoriesParts/ManageCategory.vue'
import ShippingFees from '../components/shop/pages/ShippingFees.vue'
import SaleDetails from '../components/shop/pages/salesParts/SaleDetails.vue'
import Performance from '../components/shop/pages/Performance.vue'
import ShopSettings from '../components/shop/pages/Settings.vue'
// company
import Careers from '../components/company/pages/Careers.vue'
import About from '../components/company/pages/About.vue'

Vue.use(VueRouter)

// please note the following folder name masks
// market ==> general
// account ==> user
// shop ==> shop
// auth ==> auth

// check if user is logged in
const Guard = (to, from, next) => {
  if(store.getters.authenticated !== false) {
    next() // allow to enter route
  }else{
    next('/auth/signin') // redirect to '/signin'
  }
}

// check if user has logged-in to access shop 
const shopGuard = (to, from, next) => {
  if(store.getters.authShop !== false && store.getters.authenticated !== false) {
    next() // allow to enter shop routes
  }else{
    next('/auth/lock-screen') // redirect to '/lock-screen'
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/site/search/:query',
    name: 'site-search',
    component: SiteSearch,
    props: true
  },
  {
    path: '/site/category/:category',
    name: 'category-items',
    component: CategoryItems,
    props: true
  },
  {
    path: '/site/item/:itemTitle/:itemId',
    name: 'item-details',
    component: ItemDetails,
    props: true
  },
  {
    path: '/site/item-photos/album/:itemTitle/:photoIndex/:itemId',
    name: 'photos-album',
    component: ItemPhotosAlbum,
    props: true
  },
  {
    path: '/site/shopping-cart/items/display',
    name: 'shopping-cart',
    component: ShoppingCart,
    props: true
  },
  {
    path: '/site/saved-for-later/items/display',
    name: 'saved-later',
    component: SavedForLater,
    props: true
  },
  {
    path: '/site/checkout-items/shoppers/information',
    name: 'checkout-information',
    component: Information,
    props: true
  },
  {
    path: '/site/checkout-items/shoppers/shipping/methods',
    name: 'checkout-shipping',
    component: Shipping,
    props: true
  },
  {
    path: '/site/checkout-items/shoppers/payment/options',
    name: 'checkout-payment',
    component: Payment,
    props: true
  },
  {
    path: '/site/checkout-items/shoppers/processing/order/payment/:paymentId',
    name: 'processing-order',
    component: ProcessingOrder,
    props: true
  },
  {
    path: '/site/checkout-items/shoppers/order/confirmation',
    name: 'order-confirmation',
    component: OrderConfirmation,
    props: true
  },
  {
    path: '/site/member/customer/account',
    name: 'customer-account',
    component: CustomerAccount,
    props: true,
    beforeEnter: Guard
  },
  {
    path: '/site/member/customer/orders',
    name: 'customer-orders',
    component: CustomerOrders,
    props: true,
    beforeEnter: Guard
  },
  {
    path: '/site/member/customer/order/:orderNum',
    name: 'customer-order',
    component: CustomerOrder,
    props: true
  },
  {
    path: '/site/member/customer/addresses',
    name: 'customer-addresses',
    component: CustomerAddresses,
    props: true,
    beforeEnter: Guard
  },
  {
    path: '/site/member/customer/settings',
    name: 'customer-settings',
    component: CustomerSettings,
    props: true,
    beforeEnter: Guard
  },
  {
    path: '/profile/:handle',
    name: 'lookup-handle',
    component: Profile
  },
  // {
  //   path: '/payments/item-payment/:paymentId',
  //   name: 'payment-receipt',
  //   component: PaymentReceipt
  // },
  {
    path: '/auth/termsandconditions',
    name: 'tandc',
    component: TandC
  },
  {
    path: '/auth/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy
  },
  {
    path: '/auth/signin',
    name: 'signin',
    component: Signin
  },
  {
    path: '/auth/signup',
    name: 'signup',
    component: Signup
  },
  {
    path: '/:handle/refer-a-friend',
    name: 'referral',
    component: Signup
  },
  {
    path: '/auth/recovery',
    name: 'recovery',
    component: Recovery
  },
  {
    path: '/auth/verify-email/:userId/:code',
    name: 'verify-email',
    component: VerifyEmail
  },
  {
    path: '/auth/reset-password/:email/:code',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/auth/reset-passcode/:email/:code',
    name: 'reset-passcode',
    component: ResetPasscode
  },
  {
    path: '/account/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/account/buying',
    name: 'buying',
    component: Buying,
    beforeEnter: Guard
  },
  {
    path: '/account/selling',
    name: 'selling',
    component: Selling,
    beforeEnter: Guard
  },
  {
    path: '/account/likes',
    name: 'likes',
    component: Likes,
    beforeEnter: Guard
  },
  {
    path: '/account/alerts',
    name: 'alerts',
    component: Alerts,
    beforeEnter: Guard
  },
  {
    path: '/account/alerts/:id',
    name: 'alert',
    component: Alerts,
    beforeEnter: Guard
  },
  {
    path: '/account/transactions',
    name: 'transactions',
    component: Transactions,
    beforeEnter: Guard
  },
  {
    path: '/account/anewitem',
    name: 'anewitem',
    component: PostItem,
    beforeEnter: Guard
  },
  {
    path: '/account/messages',
    name: 'messages',
    component: Messages,
    beforeEnter: Guard
  },
  {
    path: '/account/messages/:itemId',
    name: 'thread',
    component: Messages,
    beforeEnter: Guard
  },
  {
    path: '/account/settings',
    name: 'settings',
    component: Settings,
    beforeEnter: Guard
  },
  {
    path: '/account/modify-item/:id',
    name: 'modify-item',
    component: ModifyItem,
    beforeEnter: Guard
  },
  {
    path: '/account/create-shop',
    name: 'create-shop',
    component: CreateShop,
    beforeEnter: Guard
  },
  {
    path: '/auth/lock-screen',
    name: 'lock-screen',
    component: LockScreen,
    beforeEnter: Guard
  },
  {
    path: '/account/seller-plans',
    name: 'seller-plans',
    component: SellerPlans,
    beforeEnter: Guard
  },
  {
    path: '/account/create-referrer',
    name: 'create-referrer',
    component: CreateReferrer,
    beforeEnter: Guard
  },
  {
    path: '/account/portal',
    name: 'portal',
    component: Portal,
    beforeEnter: Guard
  },
  {
    path: '/account/portal-lookup/:userId',
    name: 'portal-lookup',
    component: PortalLookup,
    beforeEnter: Guard
  },
  {
    path: '/account/portal/marketers-table/:userId',
    name: 'marketers-table',
    component: Marketers,
    beforeEnter: Guard
  },
  {
    path: '/shop/dashboard',
    name: 'dashboard',
    component: Dashboard,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/items',
    name: 'items',
    component: Items,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/items/:id',
    name: 'itemId',
    component: ManageItem,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/wallet',
    name: 'wallet',
    component: Wallet,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/on-sale',
    name: 'on-sale',
    component: Sales,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/shipping/fees',
    name: 'shipping-fees',
    component: ShippingFees,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/categories',
    name: 'main-categories',
    component: MainCategories,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/categories/manage/category/:categoryName/:categoryId',
    name: 'manage-category',
    component: ManageCategory,
    props: true,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/on-sale/:id',
    name: 'saleId',
    component: SaleDetails,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/wallet/statement',
    name: 'statement',
    component: Statement,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/activities',
    name: 'activities',
    component: Activities,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/shoppers',
    name: 'shoppers',
    component: Shoppers,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/shoppers/:id',
    name: 'shoppersId',
    component: ShopperRecords,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/donations',
    name: 'donations',
    component: Donations,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/donations/history',
    name: 'donationHistory',
    component: DonationHistory,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/promotions',
    name: 'promotions',
    component: Promotions,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/promotions/promotion-plans',
    name: 'promotion-plans',
    component: PromotionPlans,
    beforeEnter: Guard
  },
  {
    path: '/shop/performance',
    name: 'performance',
    component: Performance,
    beforeEnter: shopGuard
  },
  {
    path: '/shop/settings',
    name: 'shop-settings',
    component: ShopSettings,
    // beforeEnter: shopGuard
  },
  {
    path: '/company/pages/careers',
    name: 'careers',
    component: Careers
  },
  {
    path: '/company/pages/about',
    name: 'about',
    component: About
  },
  {
    path: '*',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('appTop').scrollIntoView();
  }
})

router.beforeEach((to, from, next) => {
  // if not authenticated, before redirecting to signin page, store previous url
  let lastUrlPath = from.path
  let pathFolder = lastUrlPath.split("/")

  // ensure no auth-url path is stored to avoid loop
  if(pathFolder.includes("auth") === false){
    localStorage.setItem('_r68dt43u', lastUrlPath) // redirect url
  }
  next()
})

export default router
